import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import exampleCurrency from './exampleCurrency';
import getClubWebsite from '../../../util/clubWebsites';

/**
 * A tier's page on the club website, as the checkout looks
 * (club-website: tiers/[slug]): the tier, its price options (pick one) and
 * the member data asked for. Example prices; the club's own address.
 */
const TierWebCheckoutPreview = ({ tierName }) => {
  const s = partial('shared');
  const config = useConfig();
  const currency = exampleCurrency(config);
  const host = (getClubWebsite(config) || 'https://club.com').replace(
    /^https?:\/\//,
    ''
  );
  const options = [
    {
      key: 'monthly',
      price: `69 ${currency}`,
      per: s('tierWebPerMonth'),
      how: s('tierWebRenewsMonthly'),
    },
    {
      key: 'yearly',
      price: `1 500 ${currency}`,
      per: s('tierWebPerYear'),
      how: s('tierWebRenewsYearly'),
    },
    {
      key: 'once',
      price: `450 ${currency}`,
      per: '',
      how: s('tierWebOneTime', { months: 6 }),
    },
  ];
  const [picked, setPicked] = useState('monthly');

  return (
    <div className="tier-web">
      <div className="tier-web__bar" aria-hidden>
        <span />
        <span />
        <span />
        <span className="tier-web__url">{`${host}/tiers/gold`}</span>
      </div>
      <div className="tier-web__page">
        <div className="tier-web__tier">
          <span className="tier-web__swatch" aria-hidden />
          <span>
            <strong>{tierName}</strong>
            <span>{s('tierWebTagline')}</span>
          </span>
        </div>

        <div
          className="tier-web__options"
          role="radiogroup"
          aria-label={s('tierWebPrices')}
        >
          {options.map((option) => (
            <button
              key={option.key}
              type="button"
              role="radio"
              aria-checked={picked === option.key}
              className={`tier-web__option${
                picked === option.key ? ' tier-web__option--on' : ''
              }`}
              onClick={() => setPicked(option.key)}
            >
              <span className="tier-web__dot" aria-hidden />
              <span className="tier-web__price">
                <strong>{option.price}</strong>
                {option.per && <span>{option.per}</span>}
              </span>
              <span className="tier-web__how">{option.how}</span>
            </button>
          ))}
        </div>

        {/* The member data asked for at checkout */}
        <div className="tier-web__fields" aria-hidden>
          <span className="tier-web__field">{s('tierWebEmail')}</span>
          <span className="tier-web__field">{s('tierWebName')}</span>
          <span className="tier-web__field">{s('tierWebPhone')}</span>
        </div>
        <span className="tier-web__pay" aria-hidden>
          {s('tierWebContinue')}
        </span>
      </div>
    </div>
  );
};

TierWebCheckoutPreview.propTypes = {
  tierName: PropTypes.string.isRequired,
};

export default TierWebCheckoutPreview;
